import { BodySmall } from '#/components/Text/BodySmall';
import { getI18n } from '#/i18n/getI18n';
import type { I18nLocale } from '#/i18n/types/I18nLocale';

type Props = {
  applyText: string | null;
  locale: I18nLocale;
};

export function ListingViewApplyAtsInstructions({ applyText, locale }: Props) {
  if (!applyText) return null;

  const { i18n } = getI18n(locale);

  return (
    <BodySmall>
      <strong>{i18n('Instructions')}:</strong>{' '}
      <span
        dangerouslySetInnerHTML={{
          __html: applyText,
        }}
      />
    </BodySmall>
  );
}
